import { TFunction } from 'react-i18next'
import * as yup from 'yup'

export type ChannelEditFormFields = {
  channelDescription: string
}

export const channelEditSchema = (t: TFunction<'translation', undefined>) => {
  return yup.object({
    channelDescription: yup
      .string()
      .required(t('fieldRequired', { field: t('description') }))
      .max(200, t('fieldMaxLength', { field: t('description'), max: 200 }))
      .matches(/^\S+$/, t('fieldNoSpaces', { field: t('description') })),
  })
}
